import { NextResponse } from 'next/server';

export const generateErrorResponse = (message: string, status: number) =>
    NextResponse.json(
        {
            success: false,
            data: null,
            error: message,
        },
        { status }
    );
